export interface SparePartsFilters {
    make: string[];
    model: string[];
    modelYear: string[];
    type: string[];
    category: string[];
}

export const SPARE_PART_PRODUCT_SEARCH_PAGE_SIZE = 50;
